const EventEmitter = require('events').EventEmitter;
class AppEvents extends EventEmitter {
	constructor() {
		super();
	}
}
const events = new AppEvents();
export default events;



// WEBPACK FOOTER //
// ./app/frontend/utils-and-data/events.js